import { memo, useEffect, useState } from 'react';
import { Icon, Table, Input, Pagination, Label } from 'semantic-ui-react';
import { useTable, useSortBy, usePagination } from 'react-table';
import Fuse from 'fuse.js';

const ReactTable = ({ columns, sortColumn, sortDirection, data, isStatic, search, searchKeys = [] }) => {
  const [results, setResults] = useState([]);
  const [values, setValues] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (!isStatic) {
      setValues([...data]);
    }

    if (isStatic && !values.length) {
      setValues([...data]);
    }
    
  }, [data]);

  const fuse = new Fuse(data, {
    includeScore: true,
    keys: searchKeys,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageCount,
    gotoPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data: results,
      initialState: {
        pageIndex: 0,
        pageSize: 20,
        sortBy: [
          {
            id: sortColumn,
            desc: sortDirection === 'desc',
          },
        ],
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setResults(values);
    gotoPage(0);
    
  }, [values]);

  const handlePageChange = (e, { activePage }) => gotoPage(activePage - 1);
  const MemoRow = memo(({ row }) => (
    <Table.Row {...row.getRowProps()}>
      {row.cells.map((cell, idx) => {
        return (
          <Table.Cell {...cell.getCellProps()} key={idx}>
            {!idx && row.original.active && <Label size="tiny" color="green" ribbon content="Active" />}
            {cell.render('Cell')}
          </Table.Cell>
        );
      })}
    </Table.Row>
  ));

  const TableMemo = memo(() => (
    <Table {...getTableProps()} size="small" compact="very">
      <Table.Header>
        {headerGroups.map(headerGroup => (
          <Table.Row {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <Table.HeaderCell {...column.getHeaderProps(column.getSortByToggleProps())}>
                <>
                  {column.render('Header')}
                  {column.isSorted &&
                    (column.isSortedDesc ? <Icon name="sort descending" /> : <Icon name="sort ascending" />)}
                </>
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
      </Table.Header>
      <Table.Body {...getTableBodyProps()}>
        {page.map(row => {
          prepareRow(row);
          return <MemoRow row={row} />;
        })}
      </Table.Body>
    </Table>
  ));

  return (
    <>
      {search && (
        <div>
          <Input
            fluid
            id="table-search-input"
            icon="search"
            name="table-search-input"
            placeholder="Search..."
            type="text"
            value={searchText}
            size={'small'}
            onChange={({ target: { value } }) => {
              setSearchText(value);
              if (value?.length) {
                const result = fuse.search(value);
                setResults(result.map(r => r.item));
              } else {
                setResults(values);
              }
            }}
          />
        </div>
      )}

      <TableMemo />

      <br />

      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <Pagination
          size="tiny"
          defaultActivePage={pageIndex + 1}
          totalPages={pageCount}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default ReactTable;
